@if (isEngagementAccessRequestOpen) {
  <div>
    <kendo-dialog (close)="requestEngagementAccess(false)" [width]="500"
      [height]="210">
      <kendo-dialog-titlebar style="display: flex;">
        <p style="margin-top: 0px;margin-bottom: 0px;">You do not have access</p>
      </kendo-dialog-titlebar>
      <div style="margin-top: 10px;">
        <p>You do not have access to this engagement. Request access if needed.</p>
      </div>
      <kendo-dialog-actions [layout]="'stretched'">
        <button kendoButton type="button"  themeColor="none" (click)="requestEngagementAccess(true)" class="request-button">REQUEST ACCESS</button>
        <button kendoButton type="button" (click)="requestEngagementAccess(false)" class="w-100">CLOSE</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>
}

